import { Badge, type BadgeProps } from "@chakra-ui/react";
import type { FC, ReactNode } from "react";

type RoundedBadgeProps = {
  children: ReactNode;
} & Partial<BadgeProps>;

export const RoundedBadge: FC<RoundedBadgeProps> = (props) => {
  return <Badge py={0.5} px={2} fontSize="12px" rounded="full" {...props} />;
};
